import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { EmailSentRow } from '../person-emails-sent.part';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService): GridSetup<EmailSentRow> {

	return {
		rowName: { singular: 'Email Sent', plural: 'Emails Sent' },
		getRowKey: row => '' + row.emailSentId,
		stateKey: 'person-explorer-emails-sent-grid',
		actions: getActions(dialog),
		buttons: getButtons(),
		columns: getColumns(util),
	}
}
